module.exports = __webpack_public_path__ + "img/wallet_black.791e39dd.svg";